/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:12:06
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-17 15:51:23
 */
import req from "@/utils/request";

//  get 请求示列
export const selectPage = (params) => req.post("/interact-service/m/isUnknownQuestion/findListPage", params);
export const deleteUnknownQuestion = (params) => req.post("/interact-service/m/isUnknownQuestion/deleteUnknownQuestion", params);
export const deleteUnknownQuestionIds = (params) => req.post("/interact-service/m/isUnknownQuestion/deleteUnknownQuestionIds", params);
